// HOC shared by registration and account manager
import { withEditParentForm } from 'components/account/Parents/Edit'

// presentational component specific to registration
import UI from './UI'

// in registration flow, redirect to parents list
export default withEditParentForm({
  redirect: '/parents'
})(UI)
